import debounce from "lodash/debounce";

export default {
  data() {
    return {
      isFixed: false,
    };
  },

  created() {
    this.handleDebouncedScrollForStickyByTrigger = debounce(
      this.handleScrollForStickyByTrigger,
      10,
    );
    window.addEventListener("scroll", this.handleDebouncedScrollForStickyByTrigger);
  },

  methods: {
    handleScrollForStickyByTrigger() {
      if (!document.querySelector("[data-trigger-sticky]")) return;
      window.scrollY >= document.querySelector("[data-trigger-sticky]").offsetTop
        ? (this.isFixed = true)
        : (this.isFixed = false);
    },
  },
};
